// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class MessageActionDto extends APIModel {
    /**
    * Message action identifier
    */
    id: number;
    /**
    * Button label
    */
    caption: string;
    /**
    * Message action type
    */
    type: string;
    /**
    * Message action name
    */
    name: string;
    /**
    * Button color
    */
    color: string;
    /**
    * Url for redirect
    */
    url: string;
    /**
    * Message action values
    */
    editValues: string;
    /**
    * Message action is rendered as full width button
    */
    fullWidth: boolean;

    constructor(options?: APIModelOptions) {
        super(MessageActionDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "caption", type: "string" },
            { name: "type", type: "string" },
            { name: "name", type: "string" },
            { name: "color", type: "string" },
            { name: "url", type: "string" },
            { name: "editValues", type: "string" },
            { name: "fullWidth", type: "boolean" }
        ];
    }
}




